import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

import DescriptionIcon from '@material-ui/icons/Description';
import DialogImportCSV from "./DialogImportCSV";
import {
  IconButton,
  Button
} from "@material-ui/core";


const useStyles = makeStyles((theme) => ({
 
}));



export default function ButtonImportCSV({ project_id, reloadData }) {
  const classes = useStyles();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleOnOpen = () => {
    setIsDialogOpen(true);
  };
  const handleOnClose = () => {
    setIsDialogOpen(false);
  }; 
 
  return (
    <>
      <Button  variant="contained" startIcon={<DescriptionIcon  />} onClick={handleOnOpen}>
        Import CSV
      </Button>
      <DialogImportCSV
        //fullScreen
        open={isDialogOpen}
        onClose={handleOnClose}
        project_id={project_id}
        reloadData={reloadData}
      />
    </>
  );
}
